//Node Modules
import { useRecoilValue, useSetRecoilState } from "recoil";

//GraphQL
import { API, graphqlOperation } from "aws-amplify";
import { userDashboardConfigBySchemeId } from "../graphql/queries";
import { createUserDashboardConfig, updateUserDashboardConfig } from "../graphql/mutations";

//Atoms
import { loggedInUserAtom } from "../atoms";
import { selectedUserSchemeAtom } from "../atoms/user";
import { pinnedReportsAtom } from "../atoms/dashboard";

//dashboardAnalytics historically held a single report config object; it now holds an array
export const parsePinnedReports = (dashboardAnalytics) => {
	try {
		const parsed = JSON.parse(dashboardAnalytics);
		if (Array.isArray(parsed)) return parsed;
		if (parsed) return [parsed];
	} catch {
		//fall through
	}
	return [];
};

//Persist the pinned reports array to the user's per-scheme dashboard config and update state
export const useSavePinnedReports = () => {
	const loggedInUser = useRecoilValue(loggedInUserAtom);
	const selectedScheme = useRecoilValue(selectedUserSchemeAtom);
	const setPinnedReports = useSetRecoilState(pinnedReportsAtom);

	const savePinnedReports = async (pins) => {
		setPinnedReports(pins);

		const {
			data: {
				userDashboardConfigBySchemeId: { items: userDashboardConfig },
			},
		} = await API.graphql(
			graphqlOperation(userDashboardConfigBySchemeId, {
				cognitoUserId: { eq: loggedInUser.sub },
				schemeId: selectedScheme.id,
			}),
		);

		if (userDashboardConfig.length > 0) {
			await API.graphql(
				graphqlOperation(updateUserDashboardConfig, {
					input: { id: userDashboardConfig[0].id, dashboardAnalytics: JSON.stringify(pins) },
				}),
			);
		} else {
			await API.graphql(
				graphqlOperation(createUserDashboardConfig, {
					input: {
						cognitoUserId: loggedInUser.sub,
						schemeId: selectedScheme.id,
						dashboardAnalytics: JSON.stringify(pins),
					},
				}),
			);
		}
	};

	return savePinnedReports;
};
